import { RouteObject } from '@rocketlane/rocket-router';
import { useGetRevenueEntryAccess } from 'queries/revenue-entries/use-revenue-entries-access';
import { SecureRoute } from 'routes/route-with-permission-check';
import { ROUTE_PATHS } from 'routes/routes-paths';
import { NotFoundPage, RevenueEntryRoutes } from 'routes/vendor/lazy-imports';

const RevenueEntryRoutesLayout = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { data: access, isInitialLoading } = useGetRevenueEntryAccess();

  if (isInitialLoading) {
    return null;
  }

  // User should have access to view revenue entries
  if (access?.canView) {
    return <>{children}</>;
  }

  return <NotFoundPage />;
};

export const revenueEntryRoutes: RouteObject = {
  path: `${ROUTE_PATHS.REVENUE_ENTRIES}/${ROUTE_PATHS.MATCH_ALL}`,
  element: (
    <SecureRoute>
      <RevenueEntryRoutesLayout>
        <RevenueEntryRoutes />
      </RevenueEntryRoutesLayout>
    </SecureRoute>
  ),
};
